import { action } from 'easy-peasy';
import { IActionAddCarePlanMedicalNote } from '../types';

const addCarePlanMedicalNotes: IActionAddCarePlanMedicalNote = action((state, payload) => {
  state.items = [payload, ...state.items].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
  );
});

export default addCarePlanMedicalNotes;
